import React, { useEffect, useMemo, useRef, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";
import API from "../../../services/api";
import { BrandsTypes, formatAmount } from "../../../utils/constants";
import Select from "react-select";

const BrandWiseDetails = ({ url, newspaper_name,year, brand_type, open, onClose }) => {
  const getDefaultDateRange = (year) => ({
    startDate: `${year}-01-01`,
    endDate: `${year}-12-31`,
  });

  const [dateRange, setDateRange] = useState(getDefaultDateRange(year));
  const [data, setData] = useState([]);
  const [selectedBrandType, setSelectedBrandType] = useState(brand_type);
  const csvLinkRef = useRef(null);

  const handleDateChange = (val) => {
    if (val.startDate && val.endDate) {
      setDateRange(val);
    }
  };

  const getData = async () => {
    if(!url || !dateRange.startDate || !dateRange.endDate) return;
    try {
      const result = await API({
        url,
        method: "POST",
        data: {
          brand_type: selectedBrandType,
          newspaper_name: newspaper_name,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        },
      });

      if (result.status === "SUCCESS") {
        const fetchedData = result.data || [];

        const totals = fetchedData.reduce(
          (acc, row) => {
            acc.w2n_revenue += +row.w2n_revenue || 0;
            acc.eenadu_revenue += +row.eenadu_revenue || 0;
            return acc;
          },
          { w2n_revenue: 0, eenadu_revenue: 0 },
        );

        fetchedData.push({
          brand_id: "TOTAL",
          brand_name: "",
          sales_person_id: "",
          sales_person_name: "TOTAL",
          month: "",
          w2n_revenue: totals.w2n_revenue,
          eenadu_revenue: totals.eenadu_revenue,
          brand_location: "",
          brand_category: "",
        });

        setData(fetchedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, [selectedBrandType, dateRange]);

  const csvData = useMemo(() => {
    if (!data.length) return [];
    return data.map((row) => ({
      "Brand Name": row.brand_name ?? "",
      "Sales Person Name": row.sales_person_name ?? "",
      "W2N Revenue": row.w2n_revenue ?? "",
      "Eenadu Revenue": row.eenadu_revenue ?? "",
      "Brand Location": row.brand_location ?? "",
      "Brand Category": row.brand_category ?? "",
    }));
  }, [data]);

  if (!open) return null;

  return (
    <SlDrawer open={open} onSlAfterHide={onClose} onSlRequestClose={onClose} style={{ "--size": "50%" }}>
      <div className="p-4">
        <Datepicker
          value={dateRange}
          onChange={handleDateChange}
          primaryColor="cyan"
          showShortcuts={true}
          asSingle={false}
          displayFormat="YYYY-MM-DD"
          inputClassName="form-input"
        />

        <div className="flex flex-col my-4 min-w-[180px]">
          <Select
            options={BrandsTypes}
            value={BrandsTypes?.find((b) => +b.value === +selectedBrandType) ?? null}
            onChange={(item) => setSelectedBrandType(item?.value ?? null)}
            placeholder="Select Brand Type"
            isClearable
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>

        <div className="flex justify-end mb-3">
          <CSVLink
            data={csvData}
            filename="brandwise_details.csv"
            className="hidden"
            ref={csvLinkRef}
          />
          <button
            type="button"
            className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-60"
            onClick={() => csvLinkRef.current?.link?.click()}
            disabled={!csvData.length}
          >
            Download
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="table-auto w-full border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                {/* <th className="border px-2 py-1">Brand ID</th> */}
                <th className="border px-2 py-1">Brand Name</th>
                {/* <th className="border px-2 py-1">Sales Person ID</th> */}
                <th className="border px-2 py-1">Sales Person Name</th>
                {/* <th className="border px-2 py-1">Month</th> */}
                <th className="border px-2 py-1">W2N Revenue</th>
                <th className="border px-2 py-1">Eenadu Revenue</th>
                <th className="border px-2 py-1">Brand Location</th>
                <th className="border px-2 py-1">Brand Category</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx} className={row.brand_id === "TOTAL" ? "font-bold bg-gray-200" : ""}>
                  {/* <td className="border px-2 py-1">{row.brand_id}</td> */}
                  <td className="border px-2 py-1">{row.brand_name}</td>
                  {/* <td className="border px-2 py-1">{row.sales_person_id}</td> */}
                  <td className="border px-2 py-1">{row.sales_person_name}</td>
                  {/* <td className="border px-2 py-1">{row.month}</td> */}
                  <td className="border px-2 py-1" title={row.w2n_revenue}>{formatAmount(row.w2n_revenue || 0)}</td>
                  <td className="border px-2 py-1" title={row.eenadu_revenue}>{formatAmount(row.eenadu_revenue || 0)}</td>
                  <td className="border px-2 py-1">{row.brand_location}</td>
                  <td className="border px-2 py-1">{row.brand_category}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </SlDrawer>
  );
};

export default BrandWiseDetails;
